import {
    SET_CONTACT_LOADING,
    REMOVE_CONTACT_LOADING,
    GET_CONTACTS,
    GET_LOGGED_IN_CONTACT,
    REMOVE_LOGGED_IN_CONTACT,
    GET_CONTACT,
    SET_CONTACT_DATA,
    REMOVE_CONTACT,
    SET_CONTACT_SKELETON,
    REMOVE_CONTACT_SKELETON,
    SET_ENABLE_LOGIN,
    GET_ADD_CONTACT
} from '../types';

const initialState = {
    contact: {}, // ATTN: This is the current logged in user contact information.
    // Contacts Module
    loading: false, // Initit loading state
    contactData: {}, // ATTN: This is the contact being viewed or edited ... Might want a better name
    oldValue: ''
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_CONTACT_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_CONTACT_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_CONTACT_SKELETON:
            return {
                ...state,
                contactSkeleton: { ...payload }
            };
        case REMOVE_CONTACT_SKELETON:
            return {
                ...state,
                contactSkeleton: {}
            };
        case GET_CONTACTS:
            return {
                ...state,
                ...payload,
                loading: false
            };
        case GET_CONTACT:
        case SET_CONTACT_DATA:
        case SET_ENABLE_LOGIN:
        case GET_ADD_CONTACT:
            return {
                ...state,
                contactData: { ...payload }
            };
        case REMOVE_CONTACT:
            return {
                ...state,
                contactData: {}
            };
        case REMOVE_LOGGED_IN_CONTACT:
            return {
                ...state,
                contact: {}
            };
        case GET_LOGGED_IN_CONTACT:
            return {
                ...state,
                contact: payload
            };
        default:
            return state;
    }
}